// extracted by mini-css-extract-plugin
module.exports = {"badge":"tagBadge_badge_2HPSwmr","closeIcon":"tagBadge_closeIcon_33zaaSl"};